import { forwardRef, type Ref, type SVGProps } from "react";
const IconCafeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 44 44"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M16.5 34.375c-6.875 0-8.222-8.436-8.25-23.05-.003-1.698 1.23-3.075 2.749-3.075H30.25c1.52 0 2.752 1.377 2.749 3.074q0 .558-.005 1.104c.875.069 1.792.224 2.61.574.805.345 1.562.896 2.104 1.755.536.852.791 1.897.791 3.118 0 2.273-.572 4.128-2.042 5.353-1.114.929-2.568 1.34-4.193 1.472-.966 6.256-3.089 9.675-7.515 9.675zm16.106-12.478c.99-.14 1.651-.414 2.092-.781.592-.494 1.052-1.389 1.052-3.241 0-.842-.174-1.344-.369-1.652-.189-.3-.463-.523-.86-.694-.442-.189-.968-.29-1.563-.344-.054 2.454-.162 4.696-.352 6.712"
      clipRule="evenodd"
    />
    <path d="M8.25 37.125c0-.76.616-1.375 1.375-1.375h22a1.375 1.375 0 1 1 0 2.75h-22c-.76 0-1.375-.616-1.375-1.375" />
  </svg>
);
const ForwardRef = forwardRef(IconCafeFilledSVG);
ForwardRef.displayName = "IconCafeFilled";
export { ForwardRef as IconCafeFilled };
